import { useState, useRef } from "react";
import { Box, Stack } from "@mui/material";
// import ReportEditor from "@/components/organisms/reportEditor";
import PdfReportEditor from "./reportPDFEditor";
import { settingsState } from "@/state/settings";
import { useRecoilState } from "recoil";
import { editingFileState } from "@/client/state";

const ResizableSplitView = ({ children }: { children: React.ReactNode }) => {
  const [settings, setSettings] = useRecoilState(settingsState);
  const [leftWidth, setLeftWidth] = useState(50); // percentage
  const containerRef = useRef<HTMLDivElement>(null);

  const [editingFile] = useRecoilState(editingFileState);

  const setTextEditorOpen = (open: boolean) =>
    setSettings((prev) => ({
      ...prev,
      isTextEditorOpen: open,
      isChatHistoryOpen: !open,
    }));

  const handleMouseDown = (e: React.MouseEvent) => {
    const startX = e.clientX;
    const startWidth = leftWidth;

    const onMouseMove = (e: MouseEvent) => {
      if (!containerRef.current) return;
      const delta = e.clientX - startX;
      const newLeftWidth =
        (((containerRef.current.offsetWidth * startWidth) / 100 + delta) /
          containerRef.current.offsetWidth) *
        100;
      if (newLeftWidth > 10 && newLeftWidth < 90) {
        setLeftWidth(newLeftWidth);
      }
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        display: "grid",
        gridTemplateColumns: settings.isTextEditorOpen
          ? `${leftWidth}% 4px ${100 - leftWidth}%`
          : "1fr",
        flexGrow: 1,
        overflow: "hidden", // keep same scroll behavior as before
      }}
    >
      {/* Left side (children, same as before) */}
      <Stack direction="row" flexGrow={1} overflow="auto">
        {children}
      </Stack>

      {/* Divider (draggable) */}
      {settings.isTextEditorOpen && (
        <Box
          onMouseDown={handleMouseDown}
          sx={{
            cursor: "col-resize",
            "&:hover": { backgroundColor: "primary.main" },
          }}
        />
      )}

      {/* Right side (editor) */}
      {settings.isTextEditorOpen && (
        <Box sx={{ overflow: "auto" }}>
          {/* <ReportEditor
            docUrl={editingFile}
            onClose={() => setTextEditorOpen(false)}
          /> */}
          <PdfReportEditor
            docUrl={editingFile}
            onClose={() => setTextEditorOpen(false)}
          />
        </Box>
      )}
    </Box>
  );
};

export default ResizableSplitView;
